var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Collapse } from '../../collapse';
import { ChevronRightIcon } from '../../icon';
import { useSidebarContext } from '../sidebar-context';
import { SidebarLink } from '../sidebar-link';
import { styled } from '../../styled';
import clsx from '../../utils/clsx';
import { useControlled } from '../../utils/use-controlled';
import { useId } from '../../utils/use-id';
import { getSidebarMenuUtilityClass, sidebarMenuComponentName, sidebarMenuClasses, } from './sidebar-menu-classes';
import { useMergedClasses } from '../../styles/classes';
var Root = styled(SidebarLink, { name: sidebarMenuComponentName, slot: 'Root' })({});
var Items = styled('ul', { name: sidebarMenuComponentName, slot: 'Items' })({
    listStyle: 'none',
    margin: 0,
    padding: 0,
});
var Icon = styled(ChevronRightIcon, { name: sidebarMenuComponentName, slot: 'Icon' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return ({
        marginLeft: theme.spacing(1),
        transition: theme.transitions.create(['transform'], { duration: theme.transitions.duration.shortest }),
        transform: ownerState.expanded ? 'rotate(90deg)' : undefined,
    });
});
// const useUtilityClasses = ({ classes, expanded }: ISidebarMenuProps<any> & { expanded?: boolean }) => {
//   const slots = {
//     root: ["root"],
//     icon: ["icon", expanded && "iconExpanded"],
//     region: ["region"],
//     items: ["items"],
//   };
//   return composeClasses(slots, getSidebarMenuUtilityClass, classes as SidebarMenuClasses);
// };
export function SidebarMenuImpl(props, ref) {
    var sidebarCollapsed = useSidebarContext().collapsed;
    var className = props.className, propId = props.id, propClasses = props.classes, propIsExpanded = props.isExpanded, onExpandChange = props.onExpandChange, items = props.items, children = props.children, _a = props.defaultIsExpanded, defaultIsExpanded = _a === void 0 ? false : _a, rootProps = __rest(props, ["className", "id", "classes", "isExpanded", "onExpandChange", "items", "children", "defaultIsExpanded"]);
    var sidebarCtx = useSidebarContext();
    var id = useId(propId);
    var classes = useMergedClasses(sidebarMenuClasses, getSidebarMenuUtilityClass, propClasses);
    var titleId = "".concat(id, "-title");
    var accordionId = "".concat(id, "-accordion");
    var _b = __read(useControlled({
        controlled: propIsExpanded,
        default: defaultIsExpanded,
        name: 'SidebarMenuExpanded',
    }), 2), isExpanded = _b[0], setIsExpanded = _b[1];
    var isExpandedFinal = !sidebarCollapsed && isExpanded;
    var handleExpandChange = function () {
        var newValue = !isExpanded;
        setIsExpanded(newValue);
        if (onExpandChange) {
            onExpandChange(newValue);
        }
        // open sidebar if we need to expand and sidebar is collapsed.
        if (newValue && sidebarCtx.collapsed) {
            sidebarCtx.onCollapseChange();
        }
    };
    return (React.createElement(Root, __assign({}, rootProps, { id: id, ref: ref }, { component: 'button' }, { className: clsx(classes.root, className), "aria-current": undefined, onClick: handleExpandChange, titleId: titleId, endIcon: React.createElement(Icon, { ownerState: { expanded: isExpandedFinal }, className: clsx(classes.icon, isExpandedFinal && classes.iconExpanded) }), shouldCollapseSidebarOnClick: false, "aria-expanded": isExpandedFinal, "aria-controls": accordionId }),
        React.createElement(Collapse, { in: isExpandedFinal },
            React.createElement("div", { className: classes.region, role: "region", id: accordionId, "aria-labelledby": titleId },
                React.createElement(Items, { className: classes.items }, items
                    ? items.map(function (itemProps, i) { return React.createElement(SidebarLink, __assign({ key: i }, itemProps, { variant: "secondary", startIcon: null })); })
                    : children))),
        !!items && children));
}
export var SidebarMenu = React.forwardRef(SidebarMenuImpl);
